// extracted by mini-css-extract-plugin
module.exports = {"tagList":"_3eDYNeZG2HsGLaBGP9TPj7","tagListItem":"WzWRm-MQR5ZqaqR_k0sos","tagListGrayscaled":"_2iAPBWGBQvkjHztlAOZxWh"};